// Resolves which company's careers page to show.
// Production: {slug}.skilliq.in/careers  → slug = subdomain.
// Preview / local: fall back to a ?company= (or ?e=) query param so the
// company-scoped careers page is testable without wildcard DNS.

export const ROOT_DOMAIN = 'skilliq.in';

const RESERVED = ['www', 'app', 'api', 'mail', 'staging', 'dev', 'test', 'admin'];

export function getTenantSlug() {
  try {
    const host = window.location.hostname || '';
    if (host.endsWith('.' + ROOT_DOMAIN)) {
      const sub = host.slice(0, -(ROOT_DOMAIN.length + 1));
      if (sub && !sub.includes('.') && !RESERVED.includes(sub)) return sub;
    }
    const params = new URLSearchParams(window.location.search);
    return params.get('company') || params.get('e') || null;
  } catch (e) {
    return null;
  }
}
